import React, {Component} from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import PaymentMethodButton from '../PaymentMethodButton';
import PaymentMethodListItem from '../PaymentMethodListItem';
import {Field} from '@nexios/frontend-forms';
import styled, {withTheme} from 'styled-components';

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  row-gap: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'rowGap'], '20px')};

  div {
    justify-content: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'justifyContent'], 'space-around')};
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'justifyContent'], 'space-around')};
  row-gap: 20px;
`;

const Center = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const SpaceBetween = styled.div`
  display: flex;
  justify-content: space-between;

  button {
    width: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'width'])};
  }
`;

const VerticalListHeader = styled.div`
  color: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'headerColor'])};
  font-size: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'headerFontSize'])};
  font-weight: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'headerFontWeight'])};
  line-height: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'headerLineHeight'])};
  margin: ${props => _.get(props, ['theme', 'paymentMethodsContainer', 'headerMargin'])};
`;

const VerticalList = styled.div`
  display: flex;
  flex-direction: column;
`;

class ButtonContainer extends Component {
  static propTypes = {
    list: PropTypes.array.isRequired
  };

  render () {
    if (this.props.list === undefined) {
      return null;
    }

    if (_.get(this.props, ['theme', 'paymentMethodsContainer', 'verticalList'])) {
      return <>
        <VerticalListHeader>Betalingsmogelijkheden</VerticalListHeader>
        <VerticalList>
          {this.props.list.map((item, indx) => <Field name={this.props.fieldName} key={indx} component={
            ({setValue, validate, value: currentSelectedValue}) => <PaymentMethodListItem
              name={this.props.fieldName}
              isChecked={currentSelectedValue === item.value}
              label={item.label}
              value={item.value}
              validate={validate}
              setValue={setValue} />
          } />)}
        </VerticalList>
      </>;
    }

    const listItems = this.props.list.map((item, indx) => <Field name={this.props.fieldName} key={indx} component={
      ({setValue, validate, value: currentSelectedValue}) => <PaymentMethodButton
        isChecked={currentSelectedValue === item.value}
        label={item.label}
        value={item.value}
        validate={validate}
        setValue={setValue} />
    } />);

    if (listItems.length === 1) {
      return <Center>
        {listItems}
      </Center>;
    } else if (listItems.length === 3) {
      return <SpaceBetween>
        {listItems}
      </SpaceBetween>;
    } else if (listItems.length === 4) {
      return <MainContainer>
        <Container>{listItems[0]}{listItems[1]}</Container>
        <Container>{listItems[2]}{listItems[3]}</Container>
      </MainContainer>;
    } else {
      return <Container>
        {listItems}
      </Container>;
    }
  }
}

export default withTheme(ButtonContainer);
